// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1064":"css/app.6749","7939":"css/admin-app.6749"}[chunkId] + ".css";
};